import React from 'react';
import { intlShape, injectIntl } from 'react-intl';

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Switch from '@material-ui/core/Switch';

import Timelapse from '@material-ui/icons/Timelapse';
import Delete from '@material-ui/icons/Delete';

import randomstring from 'uuid/v4';

import { AddIcon } from '../../../../images/icons/WrapSvg';

class Machine extends React.Component {
    state = {
        idTipomaquina: '',
        prioritaria: false,
        minimo: '',
        maximo: '',
        rangos: [],
        id: '',
    };

    static getDerivedStateFromProps(props, state) {
        if (props.info && !state.id) {
            const { idTipomaquina, prioritaria, minimo, maximo, rangos } = props.info;

            state.id = props.id;
            state.prioritaria = prioritaria ? prioritaria : false;
            state.idTipomaquina = idTipomaquina ? idTipomaquina : undefined;
            state.minimo = minimo ? minimo : '';
            state.maximo = maximo ? maximo : '';
            state.rangos = rangos ? rangos : [];

            return state;
        }
        return null;
    }

    handleChange = (event) => {
        this.props.onChange(event.target.name, event.target.value, this.props.index - 1);
        this.setState({ [event.target.name]: event.target.value });
    };

    handleCheck = (event) => {
        this.props.onChange(event.target.name, event.target.checked, this.props.index - 1);
        this.setState({ [event.target.name]: event.target.checked });
    };

    handleClick = (event) => {
        const range = [...this.state.rangos];
        range.push({
            desde: '',
            hasta: '',
            produccion: '',
        });
        this.props.onChange('rangos', range, this.props.index - 1);
        this.setState({ rangos: range });
    };

    handleChangeInArray = (name, value, index) => {
        const { rangos } = this.state;
        if (rangos.length > index) {
            rangos[index][name] = value;
            this.props.onChange('rangos', rangos, this.props.index - 1);
            this.setState({ rangos: rangos });
        }
    };

    handleDelete = (index) => {
        const { rangos } = this.state;
        if (rangos.length > index) {
            rangos.splice(index, 1);
            this.props.onChange('rangos', rangos, this.props.index - 1);
            this.setState({ rangos: rangos });
        }
    };

    render() {
        const { intl, index, _machinetypes } = this.props;
        const { idTipomaquina, prioritaria, minimo, maximo, rangos } = this.state;
        return (
            <Card className={'product_card margin_top_12'}>
                <CardContent>
                    <Grid container justify="center" className={'flex_grow_1 margin_top_24'}>
                        <Grid item xs={3} className="padding_top_48">
                            <div className="flex_full_row barlow_semibold_label c_dark_grey_blue upper margin_right_18 margin_top_12 text_align_right">
                                <span>
                                    {intl.formatMessage({ id: 'recipe_machine_title' }) + index}
                                </span>
                            </div>
                            <div className="flex_full_row barlow_semibold_label center c_dark_grey_blue upper margin_top_12 text_align_left">
                                <Delete
                                    className={'c_bluish hand'}
                                    onClick={(event) => this.props.onDelete(index - 1)}
                                />
                            </div>
                        </Grid>
                        <Grid item xs={9} className="padding_top_24 padding_bottom_48">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12">
                                    <FormControl
                                        className={'flex_full width100 barlow_italic c_slate'}
                                    >
                                        <InputLabel htmlFor="idTipomaquina" shrink>
                                            {intl.formatMessage({ id: 'recipe_machine_name' })}
                                        </InputLabel>
                                        <Select
                                            native
                                            name={'idTipomaquina'}
                                            id={'idTipomaquina'}
                                            value={idTipomaquina}
                                            onChange={this.handleChange}
                                            inputProps={{
                                                name: 'idTipomaquina',
                                                id: 'idTipomaquina',
                                            }}
                                        >
                                            <option key={randomstring()} value={undefined} />
                                            {_machinetypes &&
                                                _machinetypes.length > 0 &&
                                                _machinetypes.map((u) => {
                                                    return (
                                                        <option key={randomstring()} value={u.id}>
                                                            {u.nombre}
                                                        </option>
                                                    );
                                                })}
                                        </Select>
                                    </FormControl>
                                    <div className="flex_full_row margin_bottom_12 align_center margin_left_12">
                                        <InputLabel>
                                            {intl.formatMessage({ id: 'recipe_machine_name' })}
                                        </InputLabel>
                                        <Switch
                                            id={'prioritaria'}
                                            name={'prioritaria'}
                                            label={intl.formatMessage({
                                                id: 'recipe_min_production',
                                            })}
                                            className={'flex_auto_row margin_left_12'}
                                            value={prioritaria}
                                            onChange={this.handleCheck}
                                        />
                                    </div>
                                </div>
                                <div className="flex_full_row margin_bottom_12">
                                    <TextField
                                        fullWidth
                                        id={'minimo'}
                                        name={'minimo'}
                                        required
                                        label={intl.formatMessage({ id: 'recipe_min_production' })}
                                        className={'flex_full_row'}
                                        defaultValue={minimo}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        type="number"
                                    />
                                    <TextField
                                        fullWidth
                                        id={'maximo'}
                                        name={'maximo'}
                                        required
                                        label={intl.formatMessage({ id: 'recipe_max_production' })}
                                        className={'flex_full_row margin_left_12'}
                                        defaultValue={maximo}
                                        onChange={this.handleChange}
                                        margin="normal"
                                        type="number"
                                    />
                                </div>
                            </div>
                        </Grid>
                        <Grid item xs={3} className="">
                            <div className="barlow_regular_small c_slate_grey upper margin_right_18 margin_top_12 text_align_right ">
                                {intl.formatMessage({ id: 'recipe_rules_production' })}
                            </div>
                        </Grid>
                        <Grid item xs={9} className="">
                            <div className="flex_full_column">
                                <div className="flex_full_row margin_bottom_12">
                                    <Grid
                                        container
                                        justify="center"
                                        className={'flex_grow_1 margin_top_24'}
                                    >
                                        <Grid
                                            item
                                            xs={1}
                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                        />
                                        <Grid
                                            item
                                            xs={4}
                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                        >
                                            {intl.formatMessage({ id: 'recipe_time_producion' })}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={3}
                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                        >
                                            {intl.formatMessage({
                                                id: 'recipe_units_producion_from',
                                            })}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={3}
                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                        >
                                            {intl.formatMessage({
                                                id: 'recipe_units_producion_until',
                                            })}
                                        </Grid>
                                        <Grid
                                            item
                                            xs={1}
                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                        />
                                        {rangos &&
                                            rangos.length > 0 &&
                                            rangos.map((r, indice) => {
                                                return (
                                                    <React.Fragment
                                                        key={`datosproduccion-${index}-${indice}`}
                                                    >
                                                        <Grid
                                                            item
                                                            xs={1}
                                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only center"
                                                        >
                                                            <Timelapse className={'c_bluish'} />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={4}
                                                            className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                                        >
                                                            <TextField
                                                                fullWidth
                                                                className={'flex_full_row'}
                                                                defaultValue={r.produccion}
                                                                onChange={(event) =>
                                                                    this.handleChangeInArray(
                                                                        'produccion',
                                                                        event.target.value,
                                                                        indice,
                                                                    )
                                                                }
                                                                margin="normal"
                                                                type="number"
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={3}
                                                            className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                                        >
                                                            <TextField
                                                                fullWidth
                                                                className={'flex_full_row'}
                                                                defaultValue={r.desde}
                                                                onChange={(event) =>
                                                                    this.handleChangeInArray(
                                                                        'desde',
                                                                        event.target.value,
                                                                        indice,
                                                                    )
                                                                }
                                                                margin="normal"
                                                                type="number"
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={3}
                                                            className="padding_top_12 padding_right_12 barlow_regular_small upper bg_greyish_brown shadow_down_only"
                                                        >
                                                            <TextField
                                                                fullWidth
                                                                className={'flex_full_row'}
                                                                defaultValue={r.hasta}
                                                                onChange={(event) =>
                                                                    this.handleChangeInArray(
                                                                        'hasta',
                                                                        event.target.value,
                                                                        indice,
                                                                    )
                                                                }
                                                                margin="normal"
                                                                type="number"
                                                            />
                                                        </Grid>
                                                        <Grid
                                                            item
                                                            xs={1}
                                                            className="padding_top_12 barlow_regular_small upper bg_greyish_brown shadow_down_only center"
                                                        >
                                                            <Delete
                                                                className={'c_bluish hand'}
                                                                onClick={(event) =>
                                                                    this.handleDelete(indice)
                                                                }
                                                            />
                                                        </Grid>
                                                    </React.Fragment>
                                                );
                                            })}
                                    </Grid>
                                </div>
                                <div className="flex_full_row margin_bottom_12">
                                    <div
                                        onClick={this.handleClick}
                                        className="flex_full_row margin_bottom_5 margin_top_12 padding_borders elements_center align_center barlow_medium_place_holder c_bluish uppercase dottedBox hand"
                                    >
                                        <span>{intl.formatMessage({ id: 'recipe_add_rule' })}</span>
                                        <AddIcon color="primary" className="icon" />
                                    </div>
                                </div>
                            </div>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>
        );
    }
}

Machine.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(Machine);



// WEBPACK FOOTER //
// ./src/components/complex/inventory/recipe/Machine.js